import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbInput from "../ui-kit/dfb_input"
import DfbIconButton from "../ui-kit/dfb_icon_button"
import content from "../../content"
import Section from "../blocks/section"

class MSweatRate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      weight_before: "",
      weight_after: "",
    }
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  fieldPatterns = {
    weight_before: /^(?!^0)\d{1,3}(,\d+)?$/,
    weight_after: /^(?!^0)\d{1,3}(,\d+)?$/,
  }

  isValidValue(fieldName, value) {
    if (value) {
      const pattern = this.fieldPatterns[fieldName]
      if (pattern && !pattern.exec(value)) {
        return false
      }
    }
    return true
  }

  isValid(fieldName) {
    const value = this.state[fieldName]
    return this.isValidValue(fieldName, value)
  }

  getNumberValue(fieldName) {
    const value = this.state[fieldName]
    if (value && this.isValidValue(fieldName, value)) {
      return Number.parseFloat(value.replace(",", "."))
    }
    return null
  }

  handleInputChange(event) {
    const target = event.target
    this.setState({
      [target.name]: target.value,
    })
  }

  calculateHydration() {
    const hydrationWeightLossFactorLower = 1.5
    const hydrationWeightLossFactorUpper = 2.0
    let hydrationLower = null
    let hydrationUpper = null

    const weightBefore = this.getNumberValue("weight_before")
    const weightAfter = this.getNumberValue("weight_after")

    if (weightBefore != null && weightAfter != null) {
      hydrationLower =
        (weightBefore - weightAfter) * hydrationWeightLossFactorLower
      hydrationUpper =
        (weightBefore - weightAfter) * hydrationWeightLossFactorUpper
    }

    return [
      hydrationLower != null && hydrationUpper != null
        ? {
            lower: hydrationLower.toFixed(1),
            upper: hydrationUpper.toFixed(1),
          }
        : null,
    ]
  }

  render() {
    const data = this.props?.data || {}
    const text = content.sweatRate

    const [hydration] = this.calculateHydration()

    return (
      <Section
        baseClass="m-SweatRate"
        className={this.state.has_error ? " m-SweatRate--error" : undefined}
        data={data}
      >
        <img
          className="m-SweatRate-img"
          src={text.image.src}
          alt={text.image.alt}
          data-object-fit
        />
        <div className="m-SweatRate-wrapper">
          <div className="m-SweatRate-container">
            <div className="m-SweatRate-text">
              {text.headline && (
                <DfbHeadline
                  headline={text.headline}
                  headline_level="h3"
                  add_class="u-Theme-dark m-SweatRate-headline"
                />
              )}
            </div>
            <div className="m-SweatRate-form">
              <div className="m-SweatRate-inputs">
                {["weight_before", "weight_after"].map(name => {
                  const isValid = this.isValid(name)
                  return (
                    <div className="m-SweatRate-input" key={name}>
                      <DfbInput
                        name={name}
                        label={text[`${name}_placeholder`]}
                        value={this.state[name]}
                        onChange={this.handleInputChange}
                        focused={this.state[name] !== "" ? true : false}
                        add_class={`u-Theme-dark ${
                          isValid ? "" : "dfb-Input--visibility is-invalid"
                        }`}
                        type="text"
                        errorMessage={isValid ? null : text[`${name}_error`]}
                      />
                    </div>
                  )
                })}
              </div>
              <div className="m-SweatRate-results">
                <div className="m-SweatRate-result">
                  <div className="m-SweatRate-result-label">
                    {text.hydration_placeholder}
                    {text.hydration_tooltip && (
                      <DfbIconButton
                        tagName="button"
                        icon_type="information"
                        add_class="m-SweatRate-result-info"
                        data-toggle="tooltip"
                        data-toggle-content={text.hydration_tooltip}
                        data-toggle-placement="top"
                        data-toggle-id="MSweatRateResultInfo"
                        data-toggle-offset-y="5"
                        data-toggle-inverted="true"
                      />
                    )}
                  </div>
                  <div className="m-SweatRate-result-value">
                    {hydration &&
                      hydration.lower >= 0 &&
                      hydration.lower + " - " + hydration.upper}
                  </div>
                </div>
              </div>
              <div className="m-SweatRate-error">
                {hydration === null || hydration.lower >= 0
                  ? null
                  : text.calculation_error}
              </div>
            </div>
          </div>
        </div>
      </Section>
    )
  }
}

export default MSweatRate
